import { isWeb, shadowStandard, SizableText, SmartLink, Stack, XStack, YStack } from '@my/ui'
import { RedeemOfferButton, SaveOfferButton } from 'app/features/offer/containers'
import React from 'react'
import { LinearGradient } from '@tamagui/linear-gradient'
import { OfferEndTimeTag } from './offer-end-time-tag'
import { SolitoImage } from 'solito/image'

export const BasicOfferCard = (props) => {
  const { offer, showEndTime, imagePriority } = props
  const imageUri = offer?.thumbnailImage?.url || offer?.featuredImage?.url
  return (
    <YStack flex={1} position="relative" bg="$white" br="$3" overflow="hidden" {...shadowStandard}>
      <Stack pos="absolute" flex={1} overflow="hidden" w="100%" h="100%">
        <SolitoImage
          src={imageUri}
          alt={offer?.thumbnailImage?.alt || offer?.name}
          contentFit="cover"
          fill
          sizes="389px"
          priority={imagePriority}
        />
      </Stack>

      <XStack zIndex="$1" position="absolute" top="$2.5" right="$2.5">
        <SaveOfferButton size={25} offerId={offer.id} isBookmarked={offer.isBookmarked} />
      </XStack>

      {offer?.tag && (
        <XStack
          py="$1"
          px={8}
          btrr="$2"
          bbrr="$2"
          backgroundColor="$teal5"
          zIndex="$1"
          position="absolute"
          top="$3"
          left={0}
          $gtXs={{
            py: '$2',
            px: '$3.5',
          }}
        >
          <SizableText
            textTransform="uppercase"
            color="$white"
            size="$1"
            fow="700"
            $gtXs={{
              size: '$4',
              fow: '700',
            }}
          >
            {offer.tag}
          </SizableText>
        </XStack>
      )}

      {isWeb ? (
        <div
          style={{
            backgroundImage: 'linear-gradient(0deg, rgba(0,0,0,.8), transparent)',
            position: 'absolute',
            width: '100%',
            height: '100%',
          }}
        />
      ) : (
        <LinearGradient
          width="100%"
          height="100%"
          position="absolute"
          bottom="$0"
          left="$0"
          colors={['$overlay13', '$overlay0']}
          start={[0, 1]}
          end={[0, 0]}
        />
      )}

      <SmartLink
        Component={YStack}
        flex={1}
        href={`/discounts/${offer.brand.slug}/${offer.slug}`}
        pressStyle={{
          opacity: 0.8,
        }}
        hoverStyle={{
          opacity: 0.9,
        }}
      >
        <YStack gap="$1" mt="auto" p={8} $gtXs={{ p: '$3.5', gap: '$2' }}>
          <SizableText
            tag="h3"
            color="$white"
            size="$3"
            fow="600"
            numberOfLines={3}
            $gtXs={{
              size: '$8',
              lineHeight: '$7',
              fow: '600',
            }}
          >
            {offer?.name}
          </SizableText>
          {offer.description && (
            <SizableText
              size="$2"
              numberOfLines={2}
              color="$white"
              $gtMd={{
                size: '$4',
              }}
            >
              {offer.description}
            </SizableText>
          )}
        </YStack>
      </SmartLink>

      {(showEndTime || props.offer.redeemInList) && (
        <YStack p={8} pt="$0" $gtXs={{ p: '$3.5', pt: '$0' }}>
          {props.offer.redeemInList && (
            <RedeemOfferButton
              offer={props.offer}
              buttonProps={{
                theme: 'white',
                size: '$1',
                px: '$2',
                br: '$2',
                fontWeight: '500',
                minWidth: '100%',
                h: 34,
                $gtXs: {
                  size: '$5',
                  maxWidth: '100%',
                  h: 48,
                },
              }}
              isEmbed
            />
          )}

          {showEndTime && <OfferEndTimeTag expiresAt={offer?.expiresAt} />}
        </YStack>
      )}
    </YStack>
  )
}
